var path = 'audit/audit-logs.tpl.html';
var html = " <tb-audit-log-table class=md-whiteframe-z1 flex audit-log-mode={{vm.types.auditLogMode.tenant}} page-mode=true> </tb-audit-log-table> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/audit/audit-logs.tpl.html
// module id = 1405
// module chunks = 1